/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserQuestStatsResponsePagination
 */
export interface GetUserQuestStatsResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetUserQuestStatsResponsePagination
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserQuestStatsResponsePagination
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserQuestStatsResponsePagination
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserQuestStatsResponsePagination
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the GetUserQuestStatsResponsePagination interface.
 */
export function instanceOfGetUserQuestStatsResponsePagination(value: object): value is GetUserQuestStatsResponsePagination {
    return true;
}

export function GetUserQuestStatsResponsePaginationFromJSON(json: any): GetUserQuestStatsResponsePagination {
    return GetUserQuestStatsResponsePaginationFromJSONTyped(json, false);
}

export function GetUserQuestStatsResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserQuestStatsResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'total': json['total'] == null ? undefined : json['total'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function GetUserQuestStatsResponsePaginationToJSON(json: any): GetUserQuestStatsResponsePagination {
    return GetUserQuestStatsResponsePaginationToJSONTyped(json, false);
}

export function GetUserQuestStatsResponsePaginationToJSONTyped(value?: GetUserQuestStatsResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageSize': value['pageSize'],
        'total': value['total'],
        'totalPages': value['totalPages'],
    };
}

